import { render, staticRenderFns } from "./Root.vue?vue&type=template&id=f743c194"
import script from "./Root.vue?vue&type=script&lang=ts"
export * from "./Root.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports